import * as bs from 'bootstrap';

export function initDataModal() {

    document.querySelectorAll('[data-modal]').forEach(x => {
        var element = <HTMLElement>x;
        var url = element.dataset.modal;

        x.addEventListener("click", async e => {
            var result = await fetch(url);
            var html = await result.text();
            var target = document.getElementById("modal");
            target.innerHTML = html;

            var modalElement = target.querySelector('.modal');
            var modal = new bs.Modal(modalElement);
            modal.show();
        })
    });

};